module.exports = __webpack_public_path__ + "static/media/114-high volume.932f340d.svg";